module.exports = __webpack_public_path__ + "img/consent_details.2f9e395e.svg";